import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

export interface ProjectFormData {
  projectDomain: string
  neededRoles: string[]
  projectServiceName: string
  shortSummary: string
  projectType?: string
  resultPreset?: string
  collaborationMode?: 'TEAM' | 'INDIVIDUAL'
  functionality: string
  period: string
  cost: string
  skills: string[]
  contactPhone: string
  contactEmail: string
  mainCategories: string[]
  subCategories: string[]
  referenceService: string
  materials: string[]
  designLevel: string
  engagementType: string
  weeklyHours: string
  otherRequirements: string
  startDate: string
  workType: string
}

const initialFormData: ProjectFormData = {
  projectDomain: '',
  neededRoles: [],
  projectServiceName: '',
  shortSummary: '',
  projectType: undefined,
  resultPreset: undefined,
  collaborationMode: 'TEAM',
  functionality: '',
  period: '',
  cost: '',
  skills: [],
  contactPhone: '',
  contactEmail: '',
  mainCategories: [],
  subCategories: [],
  referenceService: '',
  materials: [],
  designLevel: '',
  engagementType: '',
  weeklyHours: '',
  otherRequirements: '',
  startDate: '',
  workType: '',
}

interface ProjectFormStore {
  formData: ProjectFormData
  currentStep: number
  updateFormData: (data: Partial<ProjectFormData>) => void
  setCurrentStep: (step: number) => void
  resetForm: () => void
}

export const useProjectFormStore = create<ProjectFormStore>()(
  persist(
    (set) => ({
      formData: initialFormData,
      currentStep: 1,
      updateFormData: (data) =>
        set((state) => ({
          formData: { ...state.formData, ...data },
        })),
      setCurrentStep: (step) => set({ currentStep: step }),
      resetForm: () =>
        set({
          formData: initialFormData,
          currentStep: 1,
        }),
    }),
    {
      name: 'project-form-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
)
